import SolutionCategoryRecord from "models/view-models/situational-navigation/solutions/solution-category-record";
import ServiceFactory from "utilities/services/service-factory";
import ServiceHookFactory from "utilities/services/service-hook-factory";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

export interface AdminSolutionCategoryPathParams {
    solutionId: number;
}

export interface AdminSolutionCategoryQueryParams {
    skip?: number;
    take?: number;
}

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Constants
// -------------------------------------------------------------------------------------------------

const baseEndpoint =
    "admin/situational-navigation/solutions/:solutionId/categories";
const resourceType = SolutionCategoryRecord;

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Service
// -------------------------------------------------------------------------------------------------

const AdminSolutionCategoryService = {
    list: ServiceFactory.nestedList<
        SolutionCategoryRecord,
        AdminSolutionCategoryPathParams,
        AdminSolutionCategoryQueryParams
    >(resourceType, baseEndpoint),
    useList: ServiceHookFactory.useNestedList<
        SolutionCategoryRecord,
        AdminSolutionCategoryPathParams,
        AdminSolutionCategoryQueryParams
    >(resourceType, baseEndpoint),
    update: ServiceFactory.bulkUpdate<
        SolutionCategoryRecord,
        AdminSolutionCategoryPathParams
    >(resourceType, baseEndpoint),
    useUpdate: ServiceHookFactory.useBulkUpdate<
        SolutionCategoryRecord,
        AdminSolutionCategoryPathParams
    >(resourceType, baseEndpoint),
};

// #endregion Service

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export default AdminSolutionCategoryService;

// #endregion Exports
